import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { CustomerStory } from '@/content/customerStories/customerStories.types';
import { Row } from '@/libraries/wpl/foundations/src/grid';

import { sortStoriesByHeight } from '../utils/helpers';

import { CustomerStoriesGrid } from './customer-stories-grid';

interface CustomerStoryNoResultsFallbackProps {
	numColumns: 1 | 2 | 3;
	fallbackCustomerStories: CustomerStory[];
}

export const CustomerStoryNoResultsFallback = ({
	numColumns,
	fallbackCustomerStories,
}: CustomerStoryNoResultsFallbackProps) => {
	const intl = useIntl();

	const fallbackStoriesGrid = sortStoriesByHeight({}, fallbackCustomerStories, numColumns);
	return (
		<Row layout="12">
			<div css={customerStoryRecommendedStoriesStyles}>
				<p className="eyebrow-md">
					{intl.formatMessage({
						id: 'CustomersLandingPage.recommendedStories',
						defaultMessage: 'Recommended stories you may like',
					})}
				</p>
				<CustomerStoriesGrid storiesGrid={fallbackStoriesGrid} numColumns={numColumns} />
			</div>
		</Row>
	);
};

const customerStoryRecommendedStoriesStyles = css({
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'left',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'.eyebrow-md': {
		textTransform: 'uppercase',
		marginBlockEnd: '24px',
	},
});
